import { RiToolsLine } from '@remixicon/react';

import { Text } from '@spotify-internal/encore-web';
import {
  ToolLabel,
  ToolResultMessage,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';
import { getToolInput } from './parseToolResult';

import styles from './LoadToolsToolExtension.module.css';

const getToolNames = (input: unknown): string[] => {
  const values = getToolInput(input);
  if (!Array.isArray(values.names)) return [];

  return Array.from(
    new Set(
      values.names
        .filter((name): name is string => typeof name === 'string')
        .map(name => name.trim())
        .filter(Boolean),
    ),
  );
};

export const LoadToolsToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'load-tools',
    predicate: tool => tool === 'load_tools',
    icon: RiToolsLine,
    display: 'grouped',
    collapseConsecutiveCalls: false,
    render: () => null,
    renderLabel: (entry, { isStreaming }) => {
      const toolNames = getToolNames(entry.input);
      let label = 'Loading tools';
      if (!isStreaming && entry.result) {
        label = entry.result.success ? 'Loaded tools' : 'Failed to load tools';
      }

      return (
        <ToolLabel.Root>
          <ToolLabel.Primary>{label}</ToolLabel.Primary>
          {toolNames.length > 0 && (
            <ToolLabel.Secondary>
              {toolNames.length} {toolNames.length === 1 ? 'tool' : 'tools'}
            </ToolLabel.Secondary>
          )}
          <ToolLabel.Timer
            startedAt={entry.result ? undefined : entry.startedAt}
          />
          {(toolNames.length > 0 || entry.result) && (
            <ToolLabel.Details>
              {toolNames.map(name => (
                <Text
                  as="div"
                  variant="bodySmallMono"
                  className={styles.toolName}
                  key={name}
                >
                  {name}
                </Text>
              ))}
              {entry.result &&
                (!entry.result.success || toolNames.length === 0) && (
                  <ToolResultMessage
                    content={entry.result.content}
                    success={entry.result.success}
                  />
                )}
            </ToolLabel.Details>
          )}
        </ToolLabel.Root>
      );
    },
  }),
);
